import React from 'react';
import { DealPipelineView } from '@/components/views/DealPipelineView';

export const DebtorsPage = () => {
	return <DealPipelineView pipelineId={process.env.REACT_APP_PIPELINE_DEBTORS} />;
};
